import { render } from "./PendingConditionsAfterApprovalSummaryCard.vue?vue&type=template&id=0226d28b&scoped=true"
import script from "./PendingConditionsAfterApprovalSummaryCard.vue?vue&type=script&lang=js"
export * from "./PendingConditionsAfterApprovalSummaryCard.vue?vue&type=script&lang=js"

import "./PendingConditionsAfterApprovalSummaryCard.vue?vue&type=style&index=0&id=0226d28b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0226d28b"]])

export default __exports__